<template>
  <div class="card">
    <div class="card-body">
      <b-tabs v-model="tabIndex">
        <b-tab :title="$t('discussions.discussions')" active>
          <data-table :edit-item="editItem" />
        </b-tab>
        <b-tab v-if="userType !== 'student'" :title="$t('site.add')">
          <my-form :new-item="newItem" />
        </b-tab>
      </b-tabs>
    </div>
    <!-- end of card body -->
  </div>
</template>

<script>
import DataTableVue from "./components/DataTable.vue";
import FormVue from "./components/Form.vue";

export default {
  name: "DiscussionsIndex",
  components: {
    "data-table": DataTableVue,
    "my-form": FormVue,
  },
  data() {
    return {
      newItem: {},
      tabIndex: 0,
    };
  },
  created(){
    this.$mobileTitle.label=this.$i18n.t('discussions.discussions'); 

  },
  methods: {
    editItem(data) {
      this.form = true;
      this.newItem = data.item;
    },
  },
};
</script>
